module.exports = __webpack_public_path__ + "img/jason-de-ridder.160b4147.jpg";